import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Header, Button, Dropdown, Dimmer, Loader} from 'semantic-ui-react';

class PendingCodes extends Component {
  constructor(props) {
    super(props);
    this.state = {'selectedCode': ''};
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onAcceptClick = this.onAcceptClick.bind(this);
  }

  onChangeValue(event, {value}) {
    this.setState({'selectedCode': value});
  }

  onAcceptClick() {
    const {selectedCode} = this.state;
    const {acceptFunction, onClose} = this.props;

    acceptFunction(selectedCode);
    this.setState({'selectedCode': ''}, () => onClose());
  }

  getOptions(pendingItems) {
    return pendingItems.map((item) => ({
      'text': `${item.partCode} (${item.orderSequence})`,
      'value': item.orderSequence,
    }));
  }

  renderContent(loadingCodes, pendingItems, selectedCode) {
    if (loadingCodes) {
      return (<Modal.Content>
        <Dimmer active inverted>
          <Loader>Verificando códigos pendientes</Loader>
        </Dimmer>
      </Modal.Content>);
    }

    return (<Modal.Content>
      <Dropdown
        onChange={this.onChangeValue}
        options={this.getOptions(pendingItems)}
        value={selectedCode}
        placeholder="Seleccione un código"
        noResultsMessage='Códigos no encontrados'
        selection search fluid
      />
    </Modal.Content>);
  }

  render() {
    const {loadingCodes, pendingItems, onClose, acceptFunction, ...extraProps} = this.props;
    const {selectedCode} = this.state;

    return (<Modal {...extraProps}>
      <Header content='Códigos Pendientes' />
      {this.renderContent(loadingCodes, pendingItems, selectedCode)}
      <Modal.Actions>
        <Button content='Cancelar' onClick={onClose} />
        <Button content='Seleccionar' onClick={this.onAcceptClick} disabled={loadingCodes} primary />
      </Modal.Actions>
    </Modal>);
  }
}

const masStateToProps = (state) => {
  return {
    'loadingCodes': state.scanning.loadingPendingItemsList,
    'pendingItems': state.scanning.pendingItemsList,
  };
};

export default connect(masStateToProps)(PendingCodes);
